<template>
  <BaseFilterDialogAndChips
    :submitted-values="submittedValues"
    :show-reset-button="showResetButton"
    @open="copyFilterParams"
    @clear:filter="clearFilter"
    @reset="resetFilters"
    @submit="submitFilters"
  >
    <v-row dense>
      <v-col cols="12">
        <ContactAutocomplete
          v-model="params.client_id"
          @update:initial-item="updateAutocompleteValue('client_id', $event)"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <BaseDatepickerInput v-model="params.date_from" :label="$t('general.date_and_time.from')" />
      </v-col>

      <v-col cols="12" sm="6">
        <BaseDatepickerInput v-model="params.date_to" :label="$t('general.date_and_time.to')" />
      </v-col>
    </v-row>
  </BaseFilterDialogAndChips>
</template>

<script>
import BaseFilterDialogAndChips from '@/components/base/BaseFilterDialogAndChips';
import BaseDatepickerInput from '@/components/base/BaseDatepickerInput';
import filterMixin from '@/mixins/filter-mixin';
import { getDefaultContactOrderStatisticsFilterParams } from '@/store/modules/contact-order-statistics-module';
import ContactAutocomplete from '@/components/autocompletes/ContactAutocomplete';

export default {
  name: 'ContactOrderStatisticsFilter',

  components: { ContactAutocomplete, BaseDatepickerInput, BaseFilterDialogAndChips },

  mixins: [filterMixin],

  data() {
    return {
      defaultParams: getDefaultContactOrderStatisticsFilterParams(),
    };
  },

  computed: {
    submittedValues() {
      const values = [];
      const { client_id, date_from, date_to } = this.filterParams;

      if (client_id && this.autocompleteValues.client_id?.id === client_id) {
        values.push({
          key: 'client_id',
          value: this.autocompleteValues.client_id.name,
          label: this.$t('general.contact'),
        });
      }

      if (date_from) {
        values.push({
          key: 'date_from',
          value: date_from,
          label: this.$t('general.date_and_time.from'),
        });
      }

      if (date_to) {
        values.push({
          key: 'date_to',
          value: date_to,
          label: this.$t('general.date_and_time.to'),
        });
      }

      return values;
    },
  },
};
</script>

<style scoped></style>
